export interface PriceFavoritesList{
    name: string;
    itemsIds: string[];
}

export const DEFAULT_PRICE_FAVORITE_LIST: PriceFavoritesList = {
    name: '',
    itemsIds: []
}